<script setup lang="js">
import { useAuthStore } from "@/stores/auth";
import { computed } from "vue";

const authStore = useAuthStore();
const isLoading = computed(() => authStore.isLoading);
</script>

<template>
  <div v-if="isLoading" class="global-loading-overlay">
    <div class="loading-spinner">
      <ProgressSpinner strokeWidth="4" animationDuration="1s" />
      <p class="loading-text">Validando sessão...</p>
    </div>
  </div>

  <div class="background-animation">
    <div id="bg-gradient-1"></div>
    <div id="bg-gradient-2"></div>
    <div id="bg-gradient-3"></div>
    <div id="bg-gradient-4"></div>
  </div>

  <main>
    <RouterView />
  </main>
</template>

<style scoped>
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease-in;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.loading-text {
  color: #6b7280;
  font-size: 0.95rem;
  font-weight: 500;
  margin: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
